<template>
  <div>
    <div class="banner" :class="'banner'+type">
      <div>
        <div v-show="type==1">
          <img src="@/assets/images/program/icon-banner1.png">
          <p class="c-fff">{{$t("program.banner[0].t1")}}</p>
          <ul>
            <li v-for='item in $t("program.banner[0].t2")' v-html="item"></li>
          </ul>
        </div>
        <div v-show="type==2">
          <img src="@/assets/images/program/icon-banner2.png">
          <p class="c-fff">{{$t("program.banner[1].t1")}}</p>
          <ul>
            <li v-for='item in $t("program.banner[1].t2")' v-html="item"></li>
          </ul>
        </div>

        <div v-show="type==3">
          <img src="@/assets/images/program/icon-banner3.png">
          <p class="c-fff">{{$t("program.banner[2].t1")}}</p>
          <ul >
            <li class="c-fff" v-for='item in $t("program.banner[2].t2")' v-html="item"></li>
          </ul>
        </div>
        <div v-show="type==4">
          <img src="@/assets/images/program/icon-banner4.png">
          <p class="c-fff">{{$t("program.banner[3].t1")}}</p>
          <ul  >
            <li class="c-fff" v-for='item in $t("program.banner[3].t2")' v-html="item"></li>
          </ul>
        </div>

      </div>
    </div>
    <div class="section-wrap  ">
      <div class="disInline tl">
        <div class="c-999 program-label">
          <span @click="routerSkip('/')">{{$t('header.nav1')}}</span>  >  <span @click="routerSkip('/program')">{{$t('home.s4_1')}}</span>  >  <span @click="routerSkip('/program/list/'+type)" >{{$t('program.banner['+(type-1)+'].t1')}}</span> > <span class="c-666">{{productDetails.productName}}</span>
        </div>
        <div class="is-html" v-html="productDetails.productDetails">
        </div>
        <!--<img v-for="item in list[type][listQuery.page-1][id].list" :src="item">-->
      </div>



    </div>

  </div>
</template>

<script>
  import { getDetails } from '@api/index'

  export default {
    name: 'prize',
    data () {
      return {
         type:3,
          id:0,
          imgUrl:'../../assets/images/program/',
          listQuery:{
              size:12,
              page:1,
              totalPage:1,
              total:5
          },
          curImg:'',
          showLayerBig:false,
          curData:{},
          productDetails:'',


      }
    },
    created () {
        // console.log(this.$route.params)
        if(this.$route.params&&this.$route.params.type){
          this.type=this.$route.params.type
        }
        if(this.$route.params&&this.$route.params.id){
            this.id=parseInt(this.$route.params.id)
            this.getData()
        }
        // for(let i=1;i<=this.list[this.type][this.listQuery.page-1][this.id].total;i++){
        //     let o=this.list[this.type][this.listQuery.page-1][this.id]
        //     console.log('@/assets/images/program/pro'+this.type+'/'+(this.id+1)+'/'+o.name+(i<10?('0'+i):i)+o.suffix)
        //     this.list[this.type][this.listQuery.page-1][this.id].list.push(encodeURIComponent(require('@/assets/images/program/pro'+this.type+'/'+(this.id+1)+'/'+o.name+(i<10?('0'+i):i)+o.suffix)))
        // }
    },
    methods: {
      getData() {
          getDetails({id:this.id}).then(res=>{
              if(res.code==0){
                  this.productDetails=res.data
              }else{
                  this.$message.error(res.msg)
              }
          })
      },

    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"

  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p{
    margin: 0
  }

  .banner{height:400px;background :url("~@/assets/images/program/list-banner.png") no-repeat center/auto 100%;
    img{width:.6rem;height:auto;display :block;margin:0 auto .15rem;}
    p{font-size:.3rem;    padding-bottom: .13rem;}
      ul{width:8.34rem;margin:0 auto;}
      li{color:#fff;font-size:.14rem;line-height:.28rem;text-align :left;    list-style: disc;margin-bottom: .13rem;
      span:first-child{border-radius: 50%;width:.04rem;height:.04rem;display: inline-block;background: #666;vertical-align: middle;margin-right :.08rem;}
    }

    &.banner1{background-image :url("~@/assets/images/program/banner1.jpg")}
    &.banner2{background-image :url("~@/assets/images/program/banner2.jpg")}
    &.banner3{background-image :url("~@/assets/images/program/banner3.jpg")}
    &.banner4{background-image :url("~@/assets/images/program/banner4.jpg")}
  }
  .section-wrap{padding-bottom:.2rem;}
  .section-wrap img{width:100%;max-width:7.7rem;display :block;margin:0 auto;}
  @media screen and (max-width: 768px){
    .section-wrap{padding:0;}
    .banner{height:5.08rem;background url("~@/assets/images/program/m-list-banner1.jpg") no-repeat center/cover;font-size:.4rem;
      ul{width:6.25rem; text-align: left;}
      li{font-size:.2rem;line-height :.4rem;margin-bottom:0;color:#fff;margin-left:.24rem}

    &.banner1{background-image :url("~@/assets/images/program/m-list-banner1.jpg")}
    &.banner2{background-image :url("~@/assets/images/program/m-list-banner2.jpg")}
    &.banner3{background-image :url("~@/assets/images/program/m-list-banner3.jpg")}
    &.banner4{background-image :url("~@/assets/images/program/m-list-banner4.jpg")}
    }



  }
</style>
<style >
  body{background :#f8f8f8}

  .is-html img {
    max-width: 100%;
  }
  </style>
